import useMobile from "../../hooks/useMobile.js";
import Modal from "react-modal";
import customStyles, { customMobileStyles} from "./ModelStyles.js";
import { VscChromeClose } from "react-icons/vsc";
import classes from "./Widget.module.scss";
import { motion, AnimatePresence } from "framer-motion"

const CustomModal = (
  { isMultiSelectConfirmationVisible, 
    setIsMultiSelectConfirmationVisible,
    itemBeingSelected,
    itemBeingSelectedDependencies,
    handleConfirmationMultiSelectButtonClick
  }
) => {
    const isMobile = useMobile();

    return (
      <Modal
          isOpen={isMultiSelectConfirmationVisible}
          style={isMobile ? customMobileStyles : customStyles}
          contentLabel="Example Modal"
          ariaHideApp={false}
      >
        <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 50 }} // Start from 50px below the bottom
        animate={{ opacity: 1, y: 0 }} // Slide up to its original position
        transition={{ duration: isMobile ? 0.5 : 0}}
        exit={{ opacity: 0, y: 50 }}
      >
        <div>
          {!isMobile && (
            <VscChromeClose
              size="25"
              className={classes["modal-close-button"]}
              onClick={() => {
                setIsMultiSelectConfirmationVisible(false);
              }}
            />
          )}
          <div className={classes["modal-message"]}>
            Per selezionare{" "}
            <span className={classes["modal-item-name"]}>
              {itemBeingSelected && itemBeingSelected.name}
            </span>
            , devi necessariamente aggiungere anche:
          </div>
          <ul className={classes["modal-included-list"]}>
            {itemBeingSelected &&
              itemBeingSelectedDependencies &&
              itemBeingSelectedDependencies.map((item, index) => {
                return (
                  <li key={index} className={classes["modal-included-item"]}>
                    <span className={classes["modal-item-name"]}>
                      {item?.name}
                    </span>{" "}
                    {parseInt(item?.standard_sell_price).toFixed()} €
                  </li>
                );
              })}
          </ul>
          <button
            className={classes["modal-confirm-button"]}
            onClick={handleConfirmationMultiSelectButtonClick}
          >
            CONFERMA
          </button>
        </div>
        </motion.div>
    </AnimatePresence>
    </Modal>
)}

export default CustomModal;